import { lazy } from "react";
export var LazyAddedToCart = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "add-to-cart-notification" */ "./AddedToCart");
});
